<sdps-modal-beta sdps-title="Edit Tax Withholding Election" class="sdps-headline strong" size="medium" id="{{modalId}}">
    <div slot="modal-body">
        <mm-spinner [loading]="editTweModalState$"></mm-spinner>
        <!-- VERIFY SERVER ERROR -->
        <mm-banners *ngIf="hasError" [bannerText]="[errorMessage]" [type]="'error'" data-testid="serviceErrorBanner"></mm-banners>
        <!-- COMBINED FED AND STATE TAX ERROR -->
         <mm-banners *ngIf="updateTaxWithholdingFormGroup?.errors" [bannerText]="[fedAndStateTaxSumError]" [type]="'error'" data-testid="fed-and-state-tax-error"></mm-banners>
        <div class="sdps-text-body modal-first-line">
            <p class="elections-disclaimer-text">{{taxWithholdingText}}</p>
        </div>
        <form class="tax-input-form" [formGroup]="updateTaxWithholdingFormGroup">
            <div class="row">
                <div class="tax-container">
                    <!-- FED TAX LABEL -->
                    <div [ngClass]="fedTaxInput.invalid || updateTaxWithholdingFormGroup.errors ? 'error-text' : 'label-text'">Federal tax</div>
                    <!-- FED TAX INPUT -->
                    <div class="wrap-percent-sign-input">
                        <span class="percent-sign">%</span>
                        <input [ngClass]="fedTaxInput.invalid || updateTaxWithholdingFormGroup.errors ? 'error-input' : 'percent-input'" size="medium" type="text"
                            (paste)="onPaste($event)" data-testid="fed-tax-input"
                            (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                            maxlength="10" show-addon addon-type="text" sr-input-label="percent"
                            [formControl]="fedTaxInput" id="fed-input" name="fedInput" />
                        <!-- FED TAX ERROR -->
                        <div *ngIf="fedTaxInput?.invalid" class="alert-text" data-testid="fed-tax-error">
                            {{fedTaxError}}
                        </div>
                    </div>
                </div>
                <div class="tax-container">
                    <fieldset data-testid="state-tax-input-field">
                        <!-- STATE TAX LABEL -->
                        <div [ngClass]="stateTaxInput.invalid || updateTaxWithholdingFormGroup.errors ? 'error-text' : 'label-text'">{{stateTaxLabel}}</div>
                        <!-- STATE TAX INPUT -->
                        <div class="wrap-percent-sign-input">
                            <span [ngClass]=" hasStateTax ? 'percent-sign' : 'percent-sign-disabled'">%</span>
                            <input [ngClass]="stateTaxInput.invalid || updateTaxWithholdingFormGroup.errors ? 'error-input' : 'percent-input'" size="medium" type="text"
                                (paste)="onPaste($event)" data-testid="state-tax-input" (input)="onStateTaxInput()"
                                (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                                maxlength="10" show-addon addon-type="text" sr-input-label="percent"
                                [formControl]="stateTaxInput" id="state-input" name="stateInput"/>
                            <!-- STATE TAX ERROR -->
                            <div *ngIf="stateTaxInput?.invalid" class="alert-text" data-testid="state-tax-error">
                                {{stateTaxError}}
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="view-state-tax-info-link-container" data-testid="state-tax-info-link">
                    <a id="view-state-tax-info-link"
                        href="https://www.schwab.com/resource/state-income-tax-withholding-information-for-individual-retirement-accounts"
                        target="_blank">View state <br> tax information
                    </a>
                </div>
            </div>
        </form>
    </div>
    <div slot="modal-footer">
        <button (click)="onCancelClick()" type="button"
            class="sdps-button sdps-button--small sdps-button--secondary">Cancel</button>
        <button (click)="onApplyUpdateWithholdingClick()" type="button"
            class="sdps-button sdps-button--primary sdps-button--small" id="lc_cancel_continue">Update</button>
    </div>
</sdps-modal-beta>
